<template>
     <div v-show="parent2Show">
        <div class="upload">
            <Upload
                ref="upload"
                action="/checker_web/web/template/getEx"
                :before-upload="handleUpload"
                :format="['xlsx','xls']"
                :on-success="fileSuccessFn"
                :on-error="fileErrorFn"
                :show-upload-list="false"
                >
                <Button type="ghost" icon="ios-cloud-upload-outline">上传表头</Button>
            </Upload>
        </div>
        <Row>
            <Col span="20">
                <div v-for="(item,index) in getData" :key="index">
                    <component :is="item.model" :msg="item"></component>
                </div>
            </Col>
            <Col span="4" v-show="getData.length != 0">
                <h3 class="hd">基础信息</h3>
                <Form ref="form" :model="formItem" :rules="formValidate">
                    <Form-item label="模板名称" prop="name">
                        <Input type="text" v-model="formItem.name" placeholder="请输入..."></Input>
                    </Form-item>
                    <Form-item label="说明" prop="prompt">
                        <Input type="textarea" v-model="formItem.prompt" placeholder="请输入..."></Input>
                    </Form-item>
                </Form>
                <Button @click="submitFn">保存建立</Button>
            </Col>
        </Row>
    </div>
</template>
<script>
    import mod from './mod'
    export default {
        data(){
            return{
                formItem:{
                    name:'',
                    prompt:'',
                    textval:'',
                    type:'',
                },
                getData:[],
                formValidate:{
                    name: [
                        { required: true, message: '模板名称不能为空', trigger: 'change' }
                    ],
                    prompt: [
                        { required: true, message: '模板名称不能为空', trigger: 'change' }
                    ],
                    td: [
                        { required: true, message: '表头名称不能为空', trigger: 'change' }
                    ],
                },
            }
        },
        watch:{
            $route(to,from){
                if(to.path == '/templateList/addTemplate'){
                    this.$store.dispatch('parent2ShowFn');
                };
            }
        },
        computed: {
            parent2Show () {
                return this.$store.state.parent2Show;
            }
        },
        created(){
            this.$store.dispatch('parent2ShowFn');
        },
        methods:{
            submitFn(){
                var _this=this;
                this.$refs.form.validate((valid) => {
                    if(valid){
                        switch(this.getData[0].type){
                            case 1:
                                for(var i=0; i<this.getData[0].data.length; i++){
                                    if(this.getData[0].data[i].btnName == '未设置'){
                                        this.$Notice.error({
                                            title:'新增模板',
                                            desc:'还有未设置的选项'
                                        });
                                        return false;
                                    }
                                }
                                break;
                            case 2:
                                for(var name in this.getData[0].data){
                                    for(var i=0; i<this.getData[0].data[name].length; i++){
                                        if(this.getData[0].data[name][i].btnName == '未设置'){
                                            this.$Notice.error({
                                                title:'新增模板',
                                                desc:'还有未设置的选项'
                                            });
                                            return false;
                                        }
                                    }
                                }
                                break;
                            case 3:
                                for(var name in this.getData[0].data){
                                    for(var i=0; i<this.getData[0].data[name].length; i++){
                                        for(var item in this.getData[0].data[name][i]){
                                            for(var j=0; j<this.getData[0].data[name][i][item].length; j++){
                                                if(this.getData[0].data[name][i][item][j].btnName == '未设置'){
                                                    this.$Notice.error({
                                                        title:'新增模板',
                                                        desc:'还有未设置的选项'
                                                    });
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                }
                                break;
                        }
                        this.formItem.textval=JSON.stringify(this.getData[0].data);
                        this.formItem.type=this.getData[0].type;
                        this.$http.post('/web/template/addTemplate',_this.formItem).then(function(res){
                            if(res.success){
                                _this.$Notice.success({
                                    title:'新建模板',
                                    desc:res.message
                                });
                                _this.$router.push({path:'/templateList'});
                            }else{
                                _this.$Notice.error({
                                    title:'新建模板',
                                    desc:res.message
                                });
                            }
                        }).catch(function(res){
                            _this.$Notice.error({
                                title:'新增模板',
                                desc:'数据请求失败'
                            });
                        });
                    } else {
                        _this.$Message.error('表单验证失败!');
                    }
                });
            },
            fileSuccessFn(res){             //文件上传成功执行的钩子函数
                if(res.success){
                    this.getData=[];
                    var model='';
                    var msg={};
                    var batch={};
                    var init={};
                    switch(res.data.type){
                        case 1:
                            model = 'one'
                            msg=[];
                            batch=[];
                            for(var i=0; i<res.data.data[0].length; i++){
                                msg.push({td:res.data.data[0][i],type:4,len:null,reg:0,remarks:null,btnName:'未设置',btnData:['',''],colname:'',ruleID:'',btnIndex:i,explain_txt:'',explain_img:[]});
                            }
                            break;
                        case 2:
                            model = 'two';
                            for(let name in res.data.data){
                                msg[name]=[];
                                batch[name]=[];
                                init[name]=[];
                                for(let i=0; i<res.data.data[name].length; i++){
                                    msg[name].push({td:res.data.data[name][i],type:4,len:null,reg:0,remarks:null,btnName:'未设置',btnData:['',''],colname:'',ruleID:'',btnIndex:i,tabIndex:name,explain_txt:'',explain_img:[]});
                                }
                            }
                            break;
                        case 3:
                            model = 'three'
                            var json={};
                            var batchJson={};
                            var initJson={};
                            for(let name in res.data.data){
                                msg[name]=[];
                                batch[name]=[];
                                init[name]=[];
                                for(let i=0; i<res.data.data[name].length; i++){
                                    msg[name].push({});
                                    batch[name].push({});
                                    init[name].push({});
                                    for(let item in res.data.data[name][i]){
                                        msg[name][i][item]=[];
                                        batch[name][i][item]=[];
                                        init[name][i][item]=[];
                                        for(let j=0; j<res.data.data[name][i][item].length; j++){
                                            msg[name][i][item].push({td:res.data.data[name][i][item][j],type:4,len:null,reg:0,remarks:null,btnName:'未设置',btnData:['',''],colname:'',ruleID:'',boxIndex:name,navIndex:i,tabIndex:item,btnIndex:j,explain_txt:'',explain_img:[]});
                                        }
                                    }
                                }
                            }
                    };

                    this.getData.push({
                        data:msg,
                        batch:batch,
                        init:init,
                        model:model,
                        type:res.data.type
                    });
                    this.$Notice.success({
                        title:'文件上传',
                        desc: '上传成功',
                    });
                }else{
                    this.$Notice.error({
                        title:'文件上传',
                        desc: res.message,
                    });
                }
            },
            handleUpload(file){             //文件开始上传时执行的钩子函数
                var type=file.name.substring(file.name.lastIndexOf('.')+1,file.name.length);
                if(type === 'xlsx' || type === 'xls'){
                    this.file=file;
                }else{
                    this.$Notice.error({
                        title: '文件上传',
                        desc: '仅限.xlsx格式的文件'
                    });
                    return false;
                }   
            },
            fileErrorFn(res){
                this.$Notice.error({
                    title: '文件上传',
                    desc: '上传文件出错啦'
                });
            },
        },
        components:mod
    }
</script>
<style scoped>
    .hd{ background:#464c5b; color:#fff; }
    h3{ background:#dddee1; padding:2px 5px 2px 20px; line-height:30px; margin-top:-1px; }
</style>


// WEBPACK FOOTER //
// src/components/template/addTemplate.vue